import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import LeadCapture from "@/pages/LeadCapture";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";

import { AuthProvider } from "@/lib/AuthContext";
import { ContentProvider } from "@/lib/ContentContext";
import { TrackingProvider } from "@/lib/TrackingContext";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <TrackingProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminLayout />} />
              {/* Dynamic ad-landing routes: /start, /goa, /thailand, /uae, ... */}
              <Route path="/:slug" element={<LeadCapture />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Toaster
              position="top-center"
              richColors
              closeButton
              theme="light"
              toastOptions={{ style: { fontFamily: "Inter, sans-serif" } }}
            />
          </TrackingProvider>
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
